// hooks
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useMountpointInfo } from 'api'
import { endOfDay, startOfDay, sub } from 'date-fns'
// components
import Card from 'common/Card'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { ToggleButton } from 'ToggleButton'
import Slider from '@material-ui/core/Slider'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import MountpointUptimeChart from './MountpointUptimeInfo'
import MountpointSystemLogs from './MountpointSystemLogs'
//
import DateObject from 'react-date-object'
// constants
import { strings } from 'strings'
import { Choice } from 'Choice'

type TimeRange = 'day' | 'week' | 'month'

const MountpointLogs = () => {
  const { mid } = useParams<any>()
  const { mountpointInfo } = useMountpointInfo(mid)

  // const [fullScreen, setFullScreen] = useState(false)

  const [showDisconnects, setShowDisconnects] = useState(false)
  const [timeRange, setTimeRange] = useState<TimeRange>('day')
  const [negDays, setNegDays] = useState(0)

  const [startDate, setStartDate] = useState(() => {
    let date = new Date()
    date.setHours(0, 0, 0, 0)
    return date
  })
  const [endDate, setEndDate] = useState(new Date())

  const formatDate = (date: Date) =>
    new DateObject(date).format('YYYY/MM/DD HH:mm:ss')

  useEffect(() => {
    const updatedEndDate =
      negDays === 0 ? new Date() : endOfDay(sub(new Date(), { days: negDays }))

    setEndDate(updatedEndDate)

    setStartDate(
      startOfDay(
        sub(updatedEndDate, {
          weeks: timeRange === 'week' ? 1 : 0,
          months: timeRange === 'month' ? 1 : 0,
        }),
      ),
    )
  }, [timeRange, negDays])

  return (
    <>
      <Card
        // fullScreen={fullScreen}
        style={{ overflow: 'auto' }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <ButtonGroup disableElevation variant="outlined" size="small">
              <ToggleButton
                selected={timeRange === 'day'}
                onClick={() => setTimeRange('day')}
              >
                {strings.day}
              </ToggleButton>
              <ToggleButton
                selected={timeRange === 'week'}
                onClick={() => setTimeRange('week')}
              >
                {strings.week}
              </ToggleButton>
              <ToggleButton
                selected={timeRange === 'month'}
                onClick={() => setTimeRange('month')}
              >
                {strings.month}
              </ToggleButton>
            </ButtonGroup>
            <Choice
              labels={[strings.showDisconnects]}
              options={[]}
              onChange={() => setShowDisconnects((s) => !s)}
              value={showDisconnects}
            />
          </div>
          {timeRange === 'day' && (
            <Slider
              value={negDays}
              onChange={(_, v) => setNegDays(v as number)}
              defaultValue={0}
              step={1}
              marks
              min={0}
              max={7}
              valueLabelDisplay="auto"
              valueLabelFormat={(v) => {
                if (v === 0) return strings.today
                if (v === 1) return strings.yesterday
                return v + strings.dayBefore
              }}
              ValueLabelComponent={({ open, value, children }) => (
                <Tooltip
                  open={open}
                  enterTouchDelay={0}
                  placement="top"
                  title={value}
                >
                  {children}
                </Tooltip>
              )}
              style={{
                width: '97.5%',
              }}
            />
          )}

          <Typography
            style={{ width: '100%', textAlign: 'right', fontSize: '0.95rem' }}
          >{`${strings.from} ${formatDate(startDate)} | ${
            strings.to
          } ${formatDate(endDate)}`}</Typography>

          {mountpointInfo && (
            <>
              <MountpointUptimeChart
                mountpointId={mid}
                mountpointName={mountpointInfo.name}
                startDate={startDate}
                endDate={endDate}
                showDisconnects={showDisconnects}
              />

              <MountpointSystemLogs
                mountpointName={mountpointInfo.name}
                startDate={startDate}
              />
            </>
          )}
        </div>
      </Card>
    </>
  )
}

export default MountpointLogs
